<template>
  <div>
    <!-- Table -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          hide-default-footer
          class="sticky"
          :disable-sort="true"
          :headers="headers"
          :items="items"
          :loading="isLoadingSchedule"
        >
          <!-- Header -->
          <template v-slot:[`header.name`]="{ header }">
            <div class="mb-3">
              <div class="d-flex align-center">
                <span :style="{ fontSize: '15px'}">{{ header.text }}</span>
                <v-btn icon @click="deleteGroupDialog = true">
                  <v-icon color="error">mdi-delete-outline</v-icon>
                </v-btn>
              </div>
              <div
                class="d-flex align-center clickable"
                @click="addPeopleDialog = true"
              >
                <v-icon color="grey" small>mdi-plus</v-icon>
                <span class="grey--text">Add people</span>
              </div>
            </div>
          </template>

          <!-- Rows -->
          <template v-slot:item="{ item }">
            <tr>
              <!-- Row Name -->
              <td>
                <v-list-item dense class="px-0">
                  <v-list-item-avatar>
                    <v-icon large color="primary ">
                      mdi-account-circle
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.name || item.username"></v-list-item-title>

                    <!-- <v-list-item-subtitle>({{ item.hours }})</v-list-item-subtitle> -->
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="grey lighten-1">mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          dense link
                          @click="viewPerson(item)"
                        >
                          <v-list-item-icon class="mr-3"><v-icon>mdi-eye</v-icon></v-list-item-icon>
                          <v-list-item-title>View Details</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          dense link
                          @click="deletePerson(item)"
                        >
                          <v-list-item-icon class="mr-3"><v-icon color="error">mdi-delete-outline</v-icon></v-list-item-icon>
                          <v-list-item-title class="red--text">Remove</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-action>
                </v-list-item>
              </td>
              <!-- Row Days -->
              <td
                v-for="(day,key) in cell_days"
                :key="key"
                :class="[statusClass(item[day.value] || 'OFF'), 'text-center clickable main']"
                @click="editCell(day.value, item.id ,item[day.value] ? item.sched_id : null)"
              >
                {{ item[day.value] || 'OFF' }}
              </td>
              <!-- Row Note -->
              <td class="note">{{ item.note }}</td>
            </tr>
          </template>
        </v-data-table>

        <!-- Footer -->
        <v-row>
          <v-col>
            <h5
              class="font-weight-regular primary--text clickable text-right"
              @click="downloadReport"
            >
              Download report
            </h5>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- DIALOGS -->

    <!-- Add People -->
    <v-dialog
      v-model="addPeopleDialog"
      max-width="450px"
    >
      <v-card
        rounded="lg"
        class="pa-3 overflow-hidden"
      >
        <v-card-title class="d-flex">
          <span class="primary--text">Add People</span>
          <v-btn
            icon
            class="ml-auto"
            @click="addPeopleDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            :key="addId"
            v-model="addId"
            clearable
            rounded
            filled
            outlined
            dense
            hide-details
            class="mt-3 mb-1"
            prepend-inner-icon="mdi-magnify"
            placeholder="Search by Name or Specialization"
            :item-text="getFullName"
            :item-value="data => data"
            :search-input.sync="searchName"
            :items="peopleSearched"
            :loading="addLoading"
          ></v-autocomplete>

          <v-scroll-y-transition v-if="false">
            <div v-if="peopleSearched.length > 0" style="height:100px;overflow:auto;" class="px-3 mb-2">
              <!-- people item -->
              <div
                class="d-flex align-center"
                v-for="(person,key) in peopleSearched"
                :key="key"
              >
                <v-hover v-slot="{ hover }">
                  <v-chip
                    :color="hover ?  'grey lighten-4' : 'transparent' "
                    @click="chip2 = false"
                  >
                    <v-icon left color="primary">mdi-account-circle</v-icon>
                    {{ person }}
                    <v-icon v-show="hover" small color="primary" class="ml-1">mdi-check</v-icon>
                  </v-chip>
                </v-hover>
              </div>
            </div>
          </v-scroll-y-transition>

          <h4 class="primary--text mt-5 mb-3">People added:</h4>
          <!-- This needs a functionality where it has to divide the people added array into two and put them in different columns. -->
          <v-row>
            <v-col
              v-if="peopleAdded.length"
              cols="12"
              class="px-1 overflow-y"
              style="max-height: 50vh;"
            >
              <div
                class="d-flex align-center"
                v-for="(person,key) in peopleAdded"
                :key="key"
              >
                <v-hover v-slot="{ hover }">
                  <v-chip
                    :close="hover"
                    color="transparent"
                    @click:close="peopleAdded.splice(key, 1)"
                    close-icon="mdi-close"
                  >
                    <v-icon left color="primary">mdi-account-circle</v-icon>
                    <!-- remove person.email when tma information becomes available -->
                    {{ tabItem === 0 ? person.doctor.fullname : person.tma.fullname || person.email }}
                  </v-chip>
                </v-hover>
              </div>
            </v-col>
            <v-col
              v-else
              cols="12"
            >
              No data available
            </v-col>
            <!-- <v-col cols="6"></v-col> -->
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            depressed
            rounded
            color="primary"
            width="100px"
            class="text-none font-weight-regular mx-5"
            :loading="isSavingAddPeople"
            @click="saveAddPeople"
          >
            Save
          </v-btn>

          <v-btn
            depressed
            rounded
            color="blue lighten-4 primary--text"
            width="100px"
            class="text-none font-weight-regular mx-5"
            :disabled="isSavingAddPeople"
            @click="addPeopleDialog = false, peopleAdded = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Confirm Add People -->
    <!-- <v-dialog v-model="addConfirm" width="300px">
      <v-card>
        <v-card-title>Add to Group?</v-card-title>
        <v-card-actions class="justify-end">
          <v-btn color="secondary darken-3" @click="addConfirm = false, searchName = ''">Cancel</v-btn>
          <v-btn color="primary" @click="addPerson">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <!-- Delete Person -->
    <base-confirmation-dialog
      v-model="deletePersonDialog"
      :message="`Do you want to remove ${deletePersonData ? deletePersonData.name : ''}?`"
      @confirm="saveDeletePerson"
      @cancel="deletePersonDialog = false"
    ></base-confirmation-dialog>

    <!-- Delete Group -->
    <base-confirmation-dialog
      v-model="deleteGroupDialog"
      message="Do you want to delete this group?"
      @confirm="deleteGroup"
      @cancel="deleteGroupDialog = false"
    ></base-confirmation-dialog>

    <!-- Edit Cell -->
    <v-dialog
      v-model="editCellDialog"
      max-width="350px"
    >
      <v-card rounded="lg" class="pa-3">
        <v-card-title class="d-flex">
          <span class="primary--text">Edit Cell</span>
          <!-- <span class="primary--text">{{ editSchedId }}</span> -->
          <v-btn
            icon
            class="ml-auto"
            @click="editCellDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-radio-group
            v-model="cellStatus"
            column
          >
            <v-radio
              v-for="(status,key) in cell_statuses"
              :key="key"
              :label="status.label"
              :value="status.value"
            ></v-radio>
          </v-radio-group>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            depressed
            rounded
            color="primary"
            width="100px"
            class="text-none font-weight-regular mx-5"
            :disabled="(cellStatus == 'OFF' && !editSchedId) || (cellStatus == 'Available' && !!editSchedId) "
            :loading="isSavingEditCell"
            @click="saveEditCell"
          >
            Save
          </v-btn>

          <v-btn
            depressed
            rounded
            color="blue lighten-4 primary--text"
            width="100px"
            class="text-none font-weight-regular mx-5"
            :disabled="isSavingEditCell"
            @click="editCellDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- View Person -->
    <v-dialog
      v-model="viewPersonDialog"
      max-width="550px"
    >
      <v-card rounded="lg" class="pa-3">
        <v-card-title class="d-flex">
          <span class="primary--text">View Details</span>
          <v-btn
            icon
            class="ml-auto"
            @click="viewPersonDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- <v-card-text v-if="JSON.stringify(viewPersonData) !== JSON.stringify({})"> -->
        <v-card-text v-if="viewPersonData">
          <v-row>
            <v-col cols="6">
            <h4 class="primary--text">Name</h4>
              <span class="font-weight-black" :style="{fontSize: '15px'}">{{ viewPersonData.name }}</span>
            </v-col>
            <v-col cols="6">
              <h4 class="primary--text">Specialization</h4>
              <span>N⁄A</span>
            </v-col>
            <v-col cols="12">
              <span class="font-weight-bold">{{ cell_days[0].value | date }} - {{ cell_days[6].value | date }}</span>
            </v-col>
            <v-col cols="12">
              <!-- available -->
              <h4 class="primary--text">Days Available: {{ viewPersonData.days_available.length }}</h4>
              <span
                v-for="(day, key) in viewPersonData.days_available"
                :key="key"
                class="text-capitalize"
              >
                {{ day }}<span v-if="key !== (viewPersonData.days_available.length -1)">,</span>
              </span>
              <!-- not available -->
              <span v-if="viewPersonData.days_available.length <= 0">N⁄A</span>
            </v-col>
            <v-col cols="12">
              <!-- off -->
              <h4 class="primary--text">Days Off: {{ viewPersonData.days_off.length }}</h4>
              <span
                v-for="(day, key) in viewPersonData.days_off"
                :key="key"
                class="text-capitalize"
              >
                {{ day }}<span v-if="key !== (viewPersonData.days_off.length -1)">,</span>
              </span>
              <!-- no off -->
              <span v-if="viewPersonData.days_off.length <= 0">N⁄A</span>
            </v-col>
            <v-col cols="12">
              <!-- leave -->
              <h4 class="primary--text">Leaves: {{ viewPersonData.days_leave.length }}</h4>
              <span
                v-for="(day, key) in viewPersonData.days_leave"
                :key="key"
                class="text-capitalize"
              >
                {{ day }}<span v-if="key !== (viewPersonData.days_leave.length -1)">,</span>
              </span>
              <!-- no leave -->
              <span v-if="viewPersonData.days_leave.length <= 0">N⁄A</span>
            </v-col>
            <v-col cols="12">
              <h4 class="primary--text">Total hours rendered:</h4>
              <span>{{ viewPersonData.total_hours }} hrs</span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            depressed
            rounded
            color="blue lighten-4 primary--text"
            width="100px"
            class="text-none font-weight-regular mx-5"
            @click="viewPersonDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import API from '@/api'
  const User = API.get('User')
  const Schedule = API.get('Schedule')
  export default {
    name: 'ScheduleTable',

    props: {
      start: { type: String,  default: null},
      tabItem: { type: Number, default: 0 }
    },

    data: () => ({
      isLoadingSchedule: false,
      /**
       * Dialog/Popup
       */
      deleteGroupDialog: false,
      // view person
      viewPersonDialog: false,
      viewPersonData: null,
      // delete person
      deletePersonDialog: false,
      deletePersonData: null,
      // Add People
      addPeopleDialog: false,
      isSavingAddPeople: false,
      searchName: null,
      peopleSearched: [],
      toBeAdded: [],
      addId: null,
      addLoading: false,
      addConfirm: false,
      // Edit Cell
      cellStatus: '',
      editCellDialog: false,
      editDate: null,
      editSchedId: null,
      editUserID: null,
      isSavingEditCell: false,
      /**
       * Table Data
       */
      days: [ 'Mon 07', 'Tue 08', 'Wed 09', 'Thu 10', 'Fri 11', 'Sat 12', 'Sun 13' ],
      cell_days: [
        {
          label: 'Monday',
          value: 'mon'
        },
        {
          label: 'Tuesday',
          value: 'tue'
        },
        {
          label: 'Wednesday',
          value: 'wed'
        },
        {
          label: 'Thursday',
          value: 'thu'
        },
        {
          label: 'Friday',
          value: 'fri'
        },
        {
          label: 'Saturday',
          value: 'sat'
        },
        {
          label: 'Sunday',
          value: 'sun'
        }
      ],
      items: [],
      peopleAdded: [],
      cell_statuses: [
        {
          label: 'Available',
          value: 'Available'
        },
        {
          label: 'Off',
          value: 'OFF'
        },
        // {
        //   label: 'Service Incentive Leave',
        //   value: 'SIL'
        // }
      ]
    }),

    filters: {
      date: function (date) {
        return moment(date).format('MM⁄DD⁄YYYY');
      },
    },

    computed: {
      schedules() { return this.$store.getters['schedule/userSchedule'] },
      headers() {
        var roles = ['Doctors', 'TMA', 'Supervisor'];
        return [
          { text: roles[this.tabItem], value: 'name', width:'250px' },
          { text: this.days[0], value: 'mon', class:'grey--text text--darken-2', width:'100px'},
          { text: this.days[1], value: 'tue', class:'grey--text text--darken-2', width:'100px'},
          { text: this.days[2], value: 'wed', class:'grey--text text--darken-2', width:'100px'},
          { text: this.days[3], value: 'thu', class:'grey--text text--darken-2', width:'100px'},
          { text: this.days[4], value: 'fri', class:'grey--text text--darken-2', width:'100px'},
          { text: this.days[5], value: 'sat', class:'grey--text text--darken-2', width:'100px'},
          { text: this.days[6], value: 'sun', class:'grey--text text--darken-2', width:'100px'},
          { text: 'Note', value: 'note', class:'grey--text text--darken-2', maxWidth:'200px'},
        ]
      }
    },


    watch: {
      tabItem() {
        this.getSchedule()
      },
      start(val) { 
        this.setDates(val)
      },
      addId(val) { 
        console.log('id: ', val)
        if (val) { 
          this.peopleAdded.push(val)
          this.addid = null
        }
      },
      searchName(val) {
        // console.log('to be deleted:')
        if (val) {
          this.addLoading = true
          // prototype. Should be able to adjust to data
          if ( this.tabItem == 0 /** doctor value is 0  */ ) {
              User.getDoctors(null, { search: val }).then( ({data}) => {
                // console.log('filtered: ', data.data.filter(data=>  data.doctor ))
                this.peopleSearched = data.data.filter(data =>  
                  data.doctor 
                  && !this.items.find(item_data => item_data.username == data.username)
                  && !this.peopleAdded.find(item_data => item_data.username == data.username)
                )
              })
              .then(()=>{ this.addLoading = false})
          }
          else {
            User.getAgents(null, { search: val }).then( ({data}) => {
                this.peopleSearched = data.data.filter(data=>  
                  // remove data.email when tma information becomes available 
                  data.tma && (data.tma.fullname || data.email)
                  && !this.items.find(item_data => item_data.username == data.username)
                  && !this.peopleAdded.find(item_data => item_data.username == data.username)
                )
              })
              .then(()=>{ this.addLoading = false})
          }
        }
        else {
          this.peopleSearched = []
        }
      }
    },

    mounted() {
      this.setDates(this.start)
      console.log('[supervisor]', this.is_supervisor)
    },

    methods: {
      getFullName(data) {
         if (!data) {
           return ''
         }
         else if ( this.tabItem === 0 ) {
           return data?.doctor?.fullname
         }
         else {
           // remove data.email when tma information becomes available
           return data?.tma?.fullname || data.email
         }
        //  return data ? (this.tabItem === 0 ? data.doctor.fullname : data.tma.fullname) : null
      },
      saveAddPeople() {
        this.isSavingAddPeople = true
        // console.log(moment().format('YYYY-MM-DD'))
        // this.isSavingAddPeople = false
        this.peopleAdded.forEach( (person,index) => { 
          // console.log(index)
          Schedule.create({
            type: 'shift',
            date: moment().format('YYYY-MM-DD'),
            shift_start: moment().format('YYYY-MM-DD') + ' 08:30:00',
            shift_end: moment().format('YYYY-MM-DD') + ' 16:30:00',
            user_id: person.id,
          })
          .then(()=>{
            // console.log(response)
            if (index+1 >= this.peopleAdded.length) {
              this.isSavingAddPeople = false
              this.addPeopleDialog = false
              this.peopleAdded = []
              this.getSchedule()
            }
          })
        })
        
      },
      addPeople() {
      },
      editCell(date, user_id = null, sched_id=null,) {
        this.editDate = date
        this.editSchedId = sched_id
        this.editUserID = user_id
        this.cellStatus = sched_id ? 'Available' : 'OFF'
        this.editCellDialog = true
      },
      saveEditCell() {
        
        this.isSavingEditCell = true
        if (this.cellStatus.toLowerCase() == 'off') {
          Schedule.delete(this.editSchedId)
          .then(() => { 
            this.isSavingEditCell = false
            this.getSchedule()
            this.editCellDialog = false
          })
        }
        else if (this.cellStatus.toLowerCase() == 'available') {
          console.log('on siya yawa')
          Schedule.create({
            type: 'shift',
            date: this.editDate,
            shift_start: this.editDate + ' 08:30:00',
            shift_end: this.editDate + ' 16:30:00',
            user_id: this.editUserID,
          })
          .then(()=>{
            this.isSavingEditCell = false
            this.getSchedule()
            this.editCellDialog = false
          })
        }
      },
      viewPerson(data) {
        this.viewPersonDialog = true
        // remove data.email when tma information becomes available
        data.name = this.tabItem == 0 ? data.doctor.fullname : data?.tma?.fullname || data.email
        this.viewPersonData = this.personSchedule(data)
        console.log('view-person-data', this.viewPersonData, this.cell_days)
      },
      /**
       * Returns person's complete data with schedule
       */
      personSchedule(data) {
        data.days_available = []
        data.days_off = []
        data.days_leave = []
        data.total_hours = 0

        data.schedules.forEach(sched => {
          data.total_hours += moment(sched.shift_end).diff(sched.shift_start, 'hours')
        });
        
        this.cell_days.forEach(day => {
          if (data[day.value]) {
            // "available" schedule
            data.days_available.push(`${day.label} ${moment(day.value).format('DD')}`)
          }
          else {
            // "off" schedule
            data.days_off.push(`${day.label} ${moment(day.value).format('DD')}`)
          }
        });

        return data
      },
      deletePerson(data) {
        this.deletePersonDialog = true
        // remove data.email when tma information becomes available
        data.name = this.tabItem == 0 ? data.doctor.fullname : data?.tma?.fullname || data.email
        this.deletePersonData = data
      },
      saveDeletePerson() {
        console.log('[delete-person]', this.deletePersonData)
        this.deletePersonData.schedules.forEach((sched, index) => {
          this.$store.dispatch('schedule/deleteSchedule', sched.id)
          .then((response)=>{
            console.log('[delete-person]', response)
            if (index+1 >= this.deletePersonData.schedules.length) {
              this.isDeletingPerson = false
              this.deleteGroupDialog = false
              this.deletePersonData = {}
              this.getSchedule()
            }
          })
        });
      },
      deleteGroup() {
        //
      },
      downloadReport() {
        //
      },

      getDoctorSchedule(person, sched) {
        if (person.doctor) {
          // if not yet added
          console.log(person.username)
          if (!this.items.find( data => data.username == person.username)) {
            var new_person = person
            // console.log(sched.date)
            new_person[sched.date] = 'Available'
            new_person.name = person.doctor.fullname

            person.schedules = []
            person.schedules.push(sched)

            // console.log('testing1: ', new_person)
            this.items.push(person)
          }
          // if already added
          else {
            var person_index = this.items.findIndex( data => data.username == person.username)
            console.log(person_index)
            this.items[person_index][sched.date] = 'Available'

            this.items[person_index].schedules.push(sched)
          }
          
          // this.items.push(person)
        }
      },
      getAgentSchedule(person, sched) {
        if (person.tma) {
          // if not yet added
          console.log(person.username)
          if (!this.items.find( data => data.username == person.username)) {
            var new_person = person
            // console.log(sched.date)
            new_person[sched.date] = 'Available'
            new_person.name = person.doctor.fullname

            person.schedules = []
            person.schedules.push(sched)

            // console.log('testing1: ', new_person)
            this.items.push(person)
          }
          // if already added
          else {
            var person_index = this.items.findIndex( data => data.username == person.username)
            console.log(person_index)
            this.items[person_index][sched.date] = 'Available'

            this.items[person_index].schedules.push(sched)
          }
          
          // this.items.push(person)
        }

        // remove when tma information becomes available
        else if (person.user_type == 'tma') {
          // if not yet added
          if (!this.items.find( data => data.username == person.username)) {
            let new_person = person
            // console.log(sched.date)
            new_person[sched.date] = 'Available'
            new_person.name = person.email

            person.schedules = []
            person.schedules.push(sched)

            // console.log('testing1: ', new_person)
            this.items.push(person)
          }
          // if already added
          else {
            let person_index = this.items.findIndex( data => data.username == person.username)
            console.log(person_index)
            this.items[person_index][sched.date] = 'Available'

            this.items[person_index].schedules.push(sched)
          }
          
          // this.items.push(person)
        }
      },
      getSchedule() { 
        this.isLoadingSchedule = true
        Schedule.get().then( response =>{
          // console.log(response.data)
          var data = response.data 

          this.items = []
          data.forEach( sched => {
            // console.log(sched.date)
            if ( this.cell_days.find(day => day.value == sched.date) ) {
              let person = sched.user
              person.sched_id = sched.id

              if (this.tabItem == 0)
                this.getDoctorSchedule(person, sched)
              else
                this.getAgentSchedule(person, sched)
            }
          })
        })
        .then(()=>{ this.isLoadingSchedule = false})
      },

      setDates(start) {
        this.days = []
        this.cell_days = []
        for(var i=0; i < 7; i++) {
          var day = moment(start).add(i, 'days')
          this.days.push(day.format('ddd D'))
          // this.cell_days.
          
          // console.log(day.format('ddd'))
          this.cell_days.push({
            label: day.format('ddd').toLowerCase(),
            value: day.format('YYYY-MM-DD')
          })
        }

        this.getSchedule()
      },

      /**
       * Determine certain table cell style for specific status
       * 1. Available - blue background, primary text
       * 2. SIL - darker yellow text
       * 3. OFF - red text
       * @param {String} id - status name
       * @returns {String} - specific status class/style
       */
      statusClass(item) {
        var statusClass = ''
        switch (item) {
          case 'Available':
            statusClass = 'primary--text blue lighten-4'
            break;
          case 'SIL':
            statusClass = 'yellow--text text--darken-2'
            break;
          case 'OFF':
            statusClass = 'error--text'
            break;
          default:
            break;
        }
        return statusClass
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sticky {
    // white background - first row and first column
    td:nth-child(1), th:nth-child(1) {
      left: 0;
      position: sticky;
      top: auto;
      background-color: white;
    }
    // no border - last row
    // tr:last-child {
    //   border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
    // }
    // main cells
    .main {
      background-color: white;
      border-left: thin solid rgba(0, 0, 0, 0.12) !important;
    }
    .main:hover {
      // opacity: 0.7;
      background-color: rgba(255, 255, 255, 0.3) !important;
    }
    // note cell
    .note {
      background-color: #FFFFFF;
      border-left: thin solid rgba(0, 0, 0, 0.12);
    }
  }
</style>